<template>
    <v-card>
        <div class="pa-4">
            <div class="font-large mb-4">Breakdown:</div>
            <div class="mt-4">
                <ul class="credits-breakdown-ul">
                    <li>
                        <span class="font-weight-bold">{{ displayEstimatedArticleCreditsRequired }} credits:</span> generate content ({{ numberOfWords }} words)
                    </li>
                    <li>
                        <span class="font-weight-bold">{{ displayEstimatedRichContentCreditsRequired }} credits:</span> add rich content
                        <ul v-if="selectedCostedRichContentItems.length">
                            <li v-for="item in selectedCostedRichContentItems" :key="item.dispName || item.label">{{ item.dispName || item.label }}</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <v-btn
                outlined
                color="mainColor3"
                class="button-with-icon text-none mt-8"
                style="border-radius: 6px; border-color: var(--v-grayColor-base); width: 100%; letter-spacing: initial;"
                target="_blank"
                href="https://help.pageoptimizer.pro/article/how-pop-credits-work-with-the-pop-ai-writer"
            >
            How do credits work?
            </v-btn>

        </div>
    </v-card>
</template>

<script>

export default {
    props: [
        'selectedCostedRichContentItems',
        'numberOfWords',
        'estimatedArticleCreditsRequired',
        'estimatedRichContentCreditsRequired',
        'isWhiteGloveUser',
    ],
    data() {
        return {
            slider_options: {
                dotSize: 16,
                width: 'auto',
                height: 4,
                min: 0,
                max: 100,
                interval: 1,
                dotStyle: { border: '1px solid #D2D3D9' },
                processStyle: { background: '#FF5700' },
            },
        };
    },
    computed: {
        displayEstimatedArticleCreditsRequired() {
            return this.isWhiteGloveUser ? 0 : this.estimatedArticleCreditsRequired;
        },
        displayEstimatedRichContentCreditsRequired() {
            return this.isWhiteGloveUser ? 0 : this.estimatedRichContentCreditsRequired;
        },
    },
};
</script>
<style lang="scss" scoped>
.font-large {
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
}

.credits-breakdown-ul {
    list-style: initial;

    > li:not(:last-child) {
        margin-bottom: 8px;
    }

    ul {
        margin-top: 2px;
        list-style: initial;
        li {
            margin-bottom: 2px;
        }
    }
}

.notify-label {
    color: var(--v-mainColor3-base);
}

</style>